import React from 'react'
import { nullDate } from 'tyan/public/utility'
const minNullDate = nullDate + 1

class InstrumentAdjustDetail extends React.Component {
	state = {
		id: this.props.id || 0,
		readOnly: this.props.readOnly || false,
		canSave: this.props.canSave || false,
		canDel: this.props.canDel || false,
	}

	componentDidMount = () => {
		this.doGetInstrumentAdjust(this.state.id)
	}

	doGetInstrumentAdjust = (id) => {
		Tyan.doPostEvent('GetInstrumentAdjust', {
			data: { id },
			onEnd: ({ errorMessage, optionsParas, initValues基本信息, }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				} else {
					this.setState({ id, optionsParas, initValues基本信息, changedValues基本信息: {}, })
				}
			}
		})
	}

	handlerSave = (finish = false) => {
		const { onClose } = this.props
		const { id } = this.state
		Tyan.doPostEvent('SaveInstrumentAdjust', {
			data: { finish, ...Tyan.utility.getChangedFieldsets(this, '基本信息', false) },
			onEnd: ({ errorMessage, id }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				} else {
					this.doGetInstrumentAdjust(id)
					if (finish) this.doAutoSaveInstrumentPlan(id)
					Ext.toast(finish ? '操作成功' : '保存成功')
					onClose && onClose()
				}
			}
		})
	}

	doAutoSaveInstrumentPlan = (id) => {
		Tyan.doPostEvent('AutoSaveInstrumentPlan', {
			data: { inspectionPlanID: id },
			onEnd: ({ errorMessage, }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
			}
		})
	}

	handlerDelete = () => {
		const { onClose } = this.props
		const { id } = this.state
		Tyan.pubForm.showConfirm('确定要删除？', () => {
			Tyan.doPostEvent('DelInstrumentPlan', {
				data: { id },
				onEnd: ({ errorMessage }) => {
					if (errorMessage) {
						Tyan.pubForm.showError(errorMessage)
					} else {
						Ext.toast('删除成功')
						onClose && onClose()
					}
				}
			})
		})
	}

	handlerClose = () => {
		const { onClose } = this.props
		if (!this.bChanged()) {
			onClose && onClose()
			return
		}
		Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
	}


	canSave = () => {
		return !Tyan.checkForm.checkLimited(this) && Tyan.utility.getFormValue(this, '基本信息', '计量机构') && Tyan.utility.getFormValue(this, '基本信息', '计量结果')
	}

	bChanged = () => {
		return Tyan.utility.hasChangedValues(this)
	}


	fieldset基本信息 = () => {
		const { readOnly, canSave } = this.state
		return [
			{ _text: '设备编号', disabled: true, },
			{ _text: '设备型号', disabled: true, },
			{ _text: '设备名称', disabled: true, },
			{ _text: '英文设备名称', disabled: true, },
			{ _text: '设备厂家', disabled: true, },
			{ _text: '计划类型', disabled: true, },
			{ _text: '计划日期', disabled: true, },
			{ _text: '计量周期(月)', name: '计量周期', disabled: true, },
			{ _text: '计量内容', disabled: true, minWidth: '100%', },
			{ _text: '技术要求', disabled: true, minWidth: '100%', maxRows: 3, },
			{ _date: '计量开始日期', required: true, minValue: minNullDate, },
			{ _date: '计量结束日期', required: true, minValue: minNullDate, },
			{ _select: '计量机构', required: true, editable: true, forceSelection: false },
			{ _select: '计量结果', required: true, },
			{ _text: '备注', minWidth: '100%', maxRows: 3, },
			{ _files: '附件', minWidth: '100%', accept: '.pdf', disabled: readOnly && !canSave, },
		]
	}

	render() {
		const { showMessage: Message, showBody: Body } = this.props
		const { id, readOnly, canSave, canDel, initValues基本信息, } = this.state
		if (!initValues基本信息) return <Message text={'请稍等 ...'} />

		const bCanSave = this.canSave()
		const bChanged = this.bChanged()
		return <Body data={this} maxWidth={1000}
			controls={
				readOnly ? [
					{ _button: '保存', handler: () => this.handlerSave(false), cdt: () => canSave },
					{ _button: '删除', handler: this.handlerDelete, cdt: () => canDel },
					{ _button: '关闭', handler: this.handlerClose },
				] :
					[
						{ _button: '完成', handler: () => this.handlerSave(true), disabled: !bCanSave },
						{ _button: '保存', handler: () => this.handlerSave(false), disabled: !(bChanged && bCanSave) },
						{ _button: bChanged && '取消' || '关闭', handler: this.handlerClose },
					]
			}
			fieldsets={
				[
					{ title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: readOnly },
				]}
		/>
	}
}

export default InstrumentAdjustDetail